// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PagePublicationVersionFile,
  PagePublicationVersionFileFromJSON,
  PagePublicationVersionFileToJSON,
} from "../models/PagePublicationVersionFile";
import {
  type PagePublicationVersionSummary,
  PagePublicationVersionSummaryFromJSON,
  PagePublicationVersionSummaryToJSON,
} from "../models/PagePublicationVersionSummary";
import {
  type PublicationVersionConflictResponse,
  PublicationVersionConflictResponseFromJSON,
  PublicationVersionConflictResponseToJSON,
} from "../models/PublicationVersionConflictResponse";
import {
  type PublicationVersionCreate,
  PublicationVersionCreateFromJSON,
  PublicationVersionCreateToJSON,
} from "../models/PublicationVersionCreate";
import {
  type PublicationVersionRead,
  PublicationVersionReadFromJSON,
  PublicationVersionReadToJSON,
} from "../models/PublicationVersionRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";
import { type Version, VersionFromJSON, VersionToJSON } from "../models/Version";

export interface PublicationVersionCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  publicationVersionCreate: PublicationVersionCreate;
}

export interface PublicationVersionFilesListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  version: number;
}

export interface PublicationVersionListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: PublicationVersionListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Created by
   */
  createdBy?: string | null;
}

export interface PublicationVersionRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  version: Version;
}

/**
 *
 */
export class PublicationVersionsApi extends runtime.BaseAPI {
  /**
   * Creates request options for publicationVersionCreate without sending the request
   */
  async publicationVersionCreateRequestOpts(
    requestParameters: PublicationVersionCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationVersionCreate().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationVersionCreate().'
      );
    }

    if (requestParameters["publicationVersionCreate"] == null) {
      throw new runtime.RequiredError(
        "publicationVersionCreate",
        'Required parameter "publicationVersionCreate" was null or undefined when calling publicationVersionCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/versions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PublicationVersionCreateToJSON(requestParameters["publicationVersionCreate"]),
    };
  }

  /**
   * Create a new publication version and return result.
   * create publication version
   */
  async publicationVersionCreateRaw(
    requestParameters: PublicationVersionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PublicationVersionRead>> {
    const requestOptions = await this.publicationVersionCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicationVersionReadFromJSON(jsonValue)
    );
  }

  /**
   * Create a new publication version and return result.
   * create publication version
   */
  async publicationVersionCreate(
    requestParameters: PublicationVersionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PublicationVersionRead> {
    const response = await this.publicationVersionCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationVersionFilesList without sending the request
   */
  async publicationVersionFilesListRequestOpts(
    requestParameters: PublicationVersionFilesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationVersionFilesList().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationVersionFilesList().'
      );
    }

    if (requestParameters["version"] == null) {
      throw new runtime.RequiredError(
        "version",
        'Required parameter "version" was null or undefined when calling publicationVersionFilesList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/versions/{version}/files`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{version}",
      encodeURIComponent(String(requestParameters["version"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of files for a specific publication version.
   * list publication version files
   */
  async publicationVersionFilesListRaw(
    requestParameters: PublicationVersionFilesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PagePublicationVersionFile>> {
    const requestOptions = await this.publicationVersionFilesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PagePublicationVersionFileFromJSON(jsonValue)
    );
  }

  /**
   * Return a list of files for a specific publication version.
   * list publication version files
   */
  async publicationVersionFilesList(
    requestParameters: PublicationVersionFilesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PagePublicationVersionFile> {
    const response = await this.publicationVersionFilesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationVersionList without sending the request
   */
  async publicationVersionListRequestOpts(
    requestParameters: PublicationVersionListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationVersionList().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationVersionList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["createdBy"] != null) {
      queryParameters["created_by"] = requestParameters["createdBy"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/versions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of versions for a specific publication.
   * list publication versions
   */
  async publicationVersionListRaw(
    requestParameters: PublicationVersionListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PagePublicationVersionSummary>> {
    const requestOptions = await this.publicationVersionListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PagePublicationVersionSummaryFromJSON(jsonValue)
    );
  }

  /**
   * Return a list of versions for a specific publication.
   * list publication versions
   */
  async publicationVersionList(
    requestParameters: PublicationVersionListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PagePublicationVersionSummary> {
    const response = await this.publicationVersionListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationVersionRetrieve without sending the request
   */
  async publicationVersionRetrieveRequestOpts(
    requestParameters: PublicationVersionRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationVersionRetrieve().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationVersionRetrieve().'
      );
    }

    if (requestParameters["version"] == null) {
      throw new runtime.RequiredError(
        "version",
        'Required parameter "version" was null or undefined when calling publicationVersionRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/versions/{version}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{version}",
      encodeURIComponent(String(requestParameters["version"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual publication version.
   * show publication version details
   */
  async publicationVersionRetrieveRaw(
    requestParameters: PublicationVersionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PublicationVersionRead>> {
    const requestOptions = await this.publicationVersionRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicationVersionReadFromJSON(jsonValue)
    );
  }

  /**
   * Return detailed information of an individual publication version.
   * show publication version details
   */
  async publicationVersionRetrieve(
    requestParameters: PublicationVersionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PublicationVersionRead> {
    const response = await this.publicationVersionRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const PublicationVersionListOrderByEnum = {
  Version: "version",
  Version2: "-version",
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
} as const;
export type PublicationVersionListOrderByEnum =
  (typeof PublicationVersionListOrderByEnum)[keyof typeof PublicationVersionListOrderByEnum];
